import {
    redirect,
    useActionData,
    useLoaderData,
    useParams,
    useRevalidator,
    useSubmit,
    useSearchParams
} from "react-router-dom";
import ModalUrlWindow from "../../../../components/modalUrl";
import api from "../../../../hooks/useApi";
import {useForm} from "react-hook-form";
import {Autoform} from "../../../../components/forms/autoform";
import jsonToFormData from "../../../../hooks/jsonToFormData";
import {Box} from "@mui/material";
import {showSnackbar} from "../../../../components/snackbarUtils";
import PageTitle from "../../../../components/PageTitle";

export async function loader({request, params}) {
    const id = params.rule_id;
    const searchParams = new URL(request.url).searchParams;
    const rules_id = searchParams.get("id");
    const form = (await api.get(`api/rule/child/${rules_id}/0/`)).data.form;
    return {form};
}

export async function action({request, params}) {
    const formData = await request.formData();
    const obj_id = params.object_id;
    const rules_id = formData.get("rules_id");
    try {
        const response = await api.patch(`api/rule/child/${rules_id}/0/`, formData);

        if (response.status === 200) {
            showSnackbar("Правило успішно оновлено!", "success", {
                sx: {backgroundColor: "#1de416", color: "white"}
            });

            setTimeout(() => {
                window.location.href = `/object/${obj_id}/rules`; // Перенаправление через 1 сек
            }, 3000);
        } else {
            showSnackbar('Помилка при оновлені правила', 'error', {
                sx: {backgroundColor: "#ff0000", color: "white"}
            });
        }
    } catch (e) {
        showSnackbar(`Помилка при оновлені правила ${e}`, 'error', {
            sx: {backgroundColor: "#ff0000", color: "white"}
        });
        return {error: e}
    }
    return null;
}

export default function ObjectRulesEdit() {
    const {object_id, rule_id} = useParams();
    const submit = useSubmit();
    const [searchParams] = useSearchParams();
    const rules_id = searchParams.get("id");
    const actionData = useActionData();

    const revalidator = useRevalidator();
    const {form, data} = useLoaderData();
    const formHook = useForm();
    const handleSubmitForm = (data) => {
        const formData = jsonToFormData({...data, rules_id: rules_id});
        submit(formData, {
            method: 'post'
        })
    }

    return (
        <ModalUrlWindow
            url={`/object/${object_id}/rules`}
            title={{text: 'Змінити правило'}}
        >
            <PageTitle title={`Редагування правила: ${rules_id || rule_id || "ID"}`} />
            <Autoform
                revalidator={revalidator}
                fields={form}
                formName='HotelRules'
                formHook={formHook}
                onSubmit={handleSubmitForm}
            />
            {actionData?.response && (<Box>
                {JSON.stringify(actionData.response?.data)}
            </Box>)}
        </ModalUrlWindow>
    )
}
